import api from './api'

export const therapyRoomService = {
  list() {
    return api.get('/therapy/store/rooms')
  },
  create(payload) {
    return api.post('/therapy/store/rooms', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/store/rooms/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/store/rooms/${id}/status`, null, { params: { status } })
  },
  remove(id) {
    return api.delete(`/therapy/store/rooms/${id}`)
  }
}
